import { Injectable, inject } from '@angular/core'
import { ToastService } from '../toast-service/toast.service'

@Injectable({ providedIn: 'root' })
export class FileDropValidationService {
  private readonly toastService = inject(ToastService)

  /**
   * Rejects transferred browser data when it contains a directory.
   * @param {DataTransfer | null | undefined} dataTransfer - Browser drag or clipboard data to validate.
   * @returns {boolean} Whether the transfer was rejected.
   */
  rejectDirectories(dataTransfer: DataTransfer | null | undefined): boolean {
    const items = dataTransfer?.items
    const hasDirectory =
      !!items && Array.from(items).some(item => item.kind === 'file' && item.webkitGetAsEntry?.()?.isDirectory === true)

    if (!hasDirectory) {
      return false
    }

    this.toastService.show(q.translations.FileAttachmentComponent.folderNotSupported, { type: 'error' })

    return true
  }
}
